<template>
  <li class="itemNotice-li" style="float: left;margin: 15px">
    <div style="height:100px; width:100px;line-height: 100px;text-align: center;">
    <img :src="img" style="max-height:100%;max-width:100%;vertical-align: middle;"/>
    </div>
    <div style="width: 105px;height: 40px;text-align: center;padding-top: 8px">
      <p style="margin-bottom: 2px;color: #0052be;font-size: 14px">{{name}}</p>
      <!--<span>中国工程院院士</span>-->
    </div>
  </li>
</template>
<script>
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'character',
  props: ['img', 'name'],
  data () {
    return {
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .itemNotice-li{
    margin-left: -20px;
    margin-right: 20px
  }
  .itemNotice-a{}
  .itemNotice-span{
    float: right
  }
</style>



// WEBPACK FOOTER //
// src/components/item/itemMember.vue